import { render, staticRenderFns } from "./MatrixBlockBlogPageContent.vue?vue&type=template&id=10563e00"
import script from "./MatrixBlockBlogPageContent.vue?vue&type=script&lang=js"
export * from "./MatrixBlockBlogPageContent.vue?vue&type=script&lang=js"
import style0 from "./MatrixBlockBlogPageContent.vue?vue&type=style&index=0&id=10563e00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports